import { render, staticRenderFns } from "./autoCreateIcon.vue?vue&type=template&id=0778ecf2&scoped=true"
import script from "./autoCreateIcon.vue?vue&type=script&lang=ts"
export * from "./autoCreateIcon.vue?vue&type=script&lang=ts"
import style0 from "./autoCreateIcon.vue?vue&type=style&index=0&id=0778ecf2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778ecf2",
  null
  
)

export default component.exports